import React from "react";
import useScrollAnimation from "../components/useScrollAnimation";

const AboutusPage = () => {
  useScrollAnimation();
  const teamMembers = [
    {
      name: "John Doe",
      role: "CEO & Founder",
      imgSrc: "/john.jpg", // Replace with your image path
    },
    {
      name: "Jane Smith",
      role: "Lead Developer",
      imgSrc: "/jane.jpg", // Replace with your image path
    },
    {
      name: "Alice Johnson",
      role: "UI/UX Designer",
      imgSrc: "/alice.jpg", // Replace with your image path
    },
    {
      name: "Michael Brown",
      role: "Project Manager",
      imgSrc: "/michael.jpg", // Replace with your image path
    },
  ];

  return (
    <div
      className="min-h-screen px-8 md:px-16 py-12 bg-[#F0F0F0] z-30 relative pt-[15vh]"
      style={{ backgroundImage: "url('/bg-contact.jpg')" }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[10vh] items-center animate-fadeIn">
        {/* Left Side: Heading & Signature */}
        <div className="relative">
          {/* Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-7xl text-[#111010] font-extrabold leading-tight relative z-[50]">
            <span className="text-[#ae0c00]">W</span>HO ARE WE? AND{" "}
            <span className="text-[#ae0c00]">W</span>HY CHOOSE US
          </h1>
        </div>

        {/* Right Side: Image */}
        <div className="w-full relative lg:absolute lg:right-0 lg:top-20 z-0 md:w-2/3 lg:w-2/3 p-5 lg:p-10 ">
          <img
            src="/2.jpg"
            alt="Torne Hope"
            className="rounded-lg shadow-lg object-cover w-full h-auto lg:w-full"
          />
        </div>
      </div>

      {/* Description Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-5 animate-fadeIn">
        {/* Left Side: Description */}
        <div className="text-left">
          <p className="text-lg text-gray-600 w-full md:w-3/4 lg:w-2/3">
            Pals Infotech is a forward-thinking IT company specializing in
            delivering innovative technology solutions tailored to modern
            business needs. With expertise in software development, web design,
            and IT consulting, they empower businesses to thrive in the digital
            era.
          </p>

          <p className="mt-4 text-lg text-gray-600 w-full md:w-3/4 lg:w-2/3">
            Their dedicated team focuses on creating scalable, secure, and
            user-centric solutions. Pals Infotech values customer satisfaction,
            providing personalized support and cutting-edge technologies.
            Committed to excellence, they help businesses achieve their digital
            transformation goals efficiently.
          </p>
        </div>

        {/* Right Side: Optional Testimonial or Content */}
        <div className="hidden lg:block">
          {/* You can add testimonial or any other content here */}
        </div>
      </div>

      {/* Social Links Section (Optional) */}

      {/* Meet the Team Section */}
      {/* <div className="mt-20 animate-on-scrollUp">
        <h2 className="text-4xl md:text-5xl text-center font-extrabold text-[#111010] mb-12 ">
          <span className="text-[#ae0c00]">M</span>EET THE TEAM
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 items-center animate-fadeIn">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="text-center space-y-4 p-4 bg-white rounded-lg shadow-lg"
            >
              <img
                src={member.imgSrc}
                alt={member.name}
                className="w-full h-48 object-cover rounded-lg"
              />
              <h3 className="text-xl font-semibold text-[#111010]">
                {member.name}
              </h3>
              <p className="text-md text-gray-600">{member.role}</p>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default AboutusPage;
